export enum PermIdIndexerEnum {
    NotSet = 0,
    Home = 1,
    Hospital = 2,
    Unit = 3,
    Indicator = 4
}
